/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  FC,
  useState,
  useEffect,
  useRef
} from 'react'

import { Modal } from "react-bootstrap";

const ListCreditCards = ({isOpen, onClosed, title, text, button, onChange, isLoading, canCancel = true}) => {
  return (
    <>
      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={isOpen}
        onHide={() => onClosed()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
        <Modal.Header>
          <Modal.Title id="cancel-schedule-title" className="flex-root d-flex justify-content-center">
            <h2 className="fd-uppercase">{title}</h2>
          </Modal.Title>

          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => onClosed()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100">
            <div className='pb-10 pb-lg-15 text-center'>
              <span className='fw-bold me-5 text-justify fs-3 text-gray-800'>
                {text}
              </span>
            </div>

            <div className="d-flex flex-row mb-5">
              <button
                id="create-credit-card-button"
                type="button"
                className="btn btn-lg fw-bold btn-secondary btn-active-light w-100 mb-5 mx-1"
                onClick={() => onClosed()}
              >
                <span className="indicator-label">Fechar</span>
              </button>
              {canCancel && <button
                id="create-credit-card-button"
                type="button"
                className="btn btn-lg fw-bold btn-light-danger btn-active-danger w-100 mb-5 mx-1"
                onClick={() => onChange()}
                disabled={isLoading}
              >
                {!isLoading && <span className="indicator-label">{button}</span>}
                {isLoading && <span className="indicator-label">
                  Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>}
              </button>}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ListCreditCards;
